import React from 'react';
import PropTypes from 'prop-types';

class Header extends React.PureComponent {
    render() {
        const { logo, left, title, facilityName } = this.props;

        return (
            <div className="card-header">
                <div className="header-action left">
                    {left}
                </div>
                <div className="card-header__title">
                    <div className="card-header__desc">
                        <div className="text-bold" dangerouslySetInnerHTML={{__html: title}} />
                        <div className="text-bold">{facilityName}</div>
                    </div>
                </div>
                <div className="header-action right">
                    { (logo !== null && logo !== '') &&
                        <div className="card-header__logo">
                            <img src={logo} className="card-header__logo--image" />
                        </div>
                    }
                </div>
            </div>
        )
    }
}

Header.defaultProps = {
    left: null,
    title: null,
    logo: null,
    right: null
};

Header.propTypes = {
    left: PropTypes.node,
    title: PropTypes.node,
    logo: PropTypes.node,
    right: PropTypes.node
}

export default Header;